import FormRights from "./FormRights";

export default class FormGridRights extends FormRights {
    constructor() {
        super(...arguments);

        this.table = this.params.table;
        this.formElem = this.params.formElem;
        this.name = this.params.name;
        this.model = this.formElem.proxy.model;
        this.gridRightId = `${this._getParentRightId(this.formElem)}.${this.formElem.tableName}`;
    }

    checkColumnView() {
        return true;
    }

    checkColumnEdit(column) {
        if ( column == "ID" ) {
            return false;
        }

        return this.checkElementEdit(this.formElem);
    }

    checkFormView() {
        return this.checkElementView(this.formElem);
    }

    checkCreate() {
        return this.checkElementEdit(this.formElem);
    }

    checkEdit() {
        return this.checkElementEdit(this.formElem);
    }

    checkRemove() {
        return this.checkElementEdit(this.formElem);
    }

    checkToolbarIcon(iconName) {
        if ( system.user.isAdmin() ) {
            return true;
        }

        let rightId = `${this.gridRightId}.toolbar.${iconName}`;

        // т.к позиций счета нету в меню, то права доступа для них не настроить,
        // поэтому права для позиций счета можно взять со счета
        if ( rightId == "INVOICE_INCOMING.InvoiceForm.tab.all_positions.INVOICE_POSITIONS.toolbar.delete" ) {
            rightId = "INVOICE_INCOMING.toolbar.delete";
        }

        if ( rightId == "INVOICE_OUTGOING.InvoiceForm.tab.all_positions.INVOICE_POSITIONS.toolbar.delete" ) {
            rightId = "INVOICE_OUTGOING.toolbar.delete";
        }

        return (
            rightId in this.manager.rights.view
            || rightId in this.manager.rights.edit
        );
    }

}
